module.exports = __webpack_public_path__ + "static/media/mln.af7897f5.jpg";